import { Component, Input, OnInit, EventEmitter, Output, NgZone } from '@angular/core';
import { QueovalParam, BreadDik, BObjectModel } from '../../models';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogService } from '../../dialog';
import { BreadcrumbService } from '../../services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-postit-v3',
  templateUrl: './postit.component.html',
  styleUrls: ['./postit.component.css']
})

export class PostItV3Component implements OnInit  {

  public param: QueovalParam;
  public src: SafeResourceUrl | null;
  constructor(
    protected domSanitizer: DomSanitizer,
    private dialogservice: DialogService,
    private breadcrumbservice: BreadcrumbService
  ) { }

  @Input('param') _param: QueovalParam;
  @Output() save: EventEmitter<void> = new EventEmitter<void>();

  ngOnInit(): void {
    //const BdSrc: BreadDik | undefined = this.param.params.find((obj: BreadDik) => obj.key === 'src');
    //this.src = BdSrc ? this.domSanitizer.bypassSecurityTrustResourceUrl(BdSrc.value.toString()) : null;
    this.param = JSON.parse(JSON.stringify(this._param));
  }

  // Link du stage sur la reservation apres la sauvgarde de la reservation
  public getIdBoRdv(BOEvent: BObjectModel): void {
    this.dialogservice.showSplash(false);
    if (BOEvent && BOEvent.Error !== 'NOTVALID') {
      this.breadcrumbservice.Back();
    }
  }
}

